import { useEffect, useState } from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { api } from "../lib/api";

export const useEmployeeCustomFields = (open) => {
  const [fields, setFields] = useState([]);
  useEffect(() => {
    if (open) api.getSettings().then((s) => setFields((s?.employee_custom_fields || []).filter((f) => (f.label || "").trim()))).catch(() => {});
  }, [open]);
  return fields;
};

export const EmployeeCustomFieldsInputs = ({ fields, values, onChange }) => (
  <>
    {fields.map((f) => (
      <div key={f.key} className="space-y-1.5">
        <Label>{f.label}</Label>
        {f.type === "select" ? (
          <select data-testid={`emp-cf-${f.key}-input`} value={values?.[f.key] ?? ""} onChange={(e) => onChange(f.key, e.target.value)}
            className="h-10 w-full rounded-md border border-slate-200 bg-white px-3 text-sm">
            <option value="">—</option>
            {(f.options || []).map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        ) : (
          <Input data-testid={`emp-cf-${f.key}-input`} type={f.type === "date" ? "date" : f.type === "number" ? "number" : "text"}
            dir={f.type === "text" ? undefined : "ltr"} value={values?.[f.key] ?? ""} onChange={(e) => onChange(f.key, e.target.value)} />
        )}
      </div>
    ))}
  </>
);
